import { whyItems } from "../../../mocks/services";

export default function WhyChooseUs() {
  return (
    <section className="bg-[#F8F7F4] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1fr_1.6fr] gap-14 items-start">
          {/* Left */}
          <div>
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">
              Why Jerry's
            </p>
            <h2
              className="text-4xl lg:text-5xl font-black text-gray-900 mb-5 leading-tight"
              style={{ fontFamily: "'Barlow', sans-serif" }}
            >
              Why Homeowners
              <br />
              Choose{" "}
              <span className="text-[#E8500A]">Jerry's</span>
            </h2>
            <p className="text-gray-500 leading-relaxed mb-8 text-base">
              When plumbing or heating work needs to be done right, experience and trust are everything. For over 35 years, DFW homeowners and businesses have called Jerry&apos;s because we deliver — every time.
            </p>

            {/* Core values */}
            <div className="space-y-3 mb-8">
              {[
                { label: "Reliability You Can Count On", icon: "ri-shield-check-fill" },
                { label: "Integrity in Every Job", icon: "ri-handshake-fill" },
                { label: "100% Customer Satisfaction", icon: "ri-emotion-happy-fill" },
              ].map((val) => (
                <div
                  key={val.label}
                  className="flex items-center gap-4 bg-white rounded-xl px-5 py-3.5 border border-gray-100"
                >
                  <span className="w-9 h-9 flex items-center justify-center bg-orange-50 rounded-lg flex-shrink-0">
                    <i className={`${val.icon} text-[#E8500A] text-base`} />
                  </span>
                  <strong className="text-gray-900 font-bold text-sm">{val.label}</strong>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-4 p-6 bg-[#0B1829] rounded-2xl">
              {[
                { val: "35+", lab: "Years in DFW" },
                { val: "24/7", lab: "Emergency Service" },
                { val: "5★", lab: "Customer Rated" },
                { val: "100%", lab: "Locally Owned" },
              ].map((s) => (
                <div key={s.lab} className="text-center">
                  <p
                    className="text-3xl font-black text-[#E8500A]"
                    style={{ fontFamily: "'Barlow', sans-serif" }}
                  >
                    {s.val}
                  </p>
                  <p className="text-gray-400 text-xs font-medium mt-0.5">{s.lab}</p>
                </div>
              ))}
            </div>

            <a
              href="tel:8178324968"
              className="inline-flex items-center gap-2 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold px-7 py-3.5 rounded-lg text-sm transition-colors mt-6 whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              Call (817) 832-4968
            </a>
          </div>

          {/* Right Grid */}
          <div className="grid sm:grid-cols-2 gap-4">
            {whyItems.map((item) => (
              <div
                key={item.title}
                className="group bg-white hover:bg-[#E8500A] rounded-2xl p-6 transition-all duration-300 border border-gray-100 hover:border-[#E8500A]"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-50 group-hover:bg-white/20 mb-4 transition-colors">
                  <i
                    className={`${item.icon} text-[#E8500A] group-hover:text-white text-xl transition-colors`}
                  />
                </div>
                <h3
                  className="font-black text-gray-900 group-hover:text-white text-base mb-2 transition-colors"
                  style={{ fontFamily: "'Barlow', sans-serif" }}
                >
                  {item.title}
                </h3>
                <p className="text-gray-500 group-hover:text-white/75 text-sm leading-relaxed transition-colors">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
